// extracted by mini-css-extract-plugin
export var grid = "TwoColumnImage-module--grid--6cd81";
export var image = "TwoColumnImage-module--image--44480";